import React, { useContext, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getScreams } from "../redux/actions/dataActions";
import { ChessSocialContext } from "../util/ChessSocialContext";
import { GoogleAuthProvider } from "firebase/auth";
import { useLocation } from "react-router-dom";
import CrownGold from "../images/CrownGold.png";
import CrownSilver from "../images/CrownSilver.png";
import CrownBronze from "../images/CrownBronze.png";

import chessslogo from "../images/chessslogo.png";
import mansalva from '../images/Mansalva/Mansalva-Regular.ttf';

// Add a style block to define the font-face
const MansalvaFontStyle = () => {
  return (
    <style>
      {`
        @font-face {
          font-family: 'Mansalva';
          src: url(${mansalva}) format('truetype');
          font-weight: normal;
          font-style: normal;
          font-display: swap;
        }
      `}
    </style>
  );
};


const Premium = (props) => {
  const { setActiveTab, activeTab, setIsSidebarCollapsed } = useContext(ChessSocialContext);
  const location = useLocation();
  const [showRedirectMessage, setShowRedirectMessage] = useState(false);
  const [attemptedPath, setAttemptedPath] = useState('');
  const topRef = useRef(null);

  // Function to scroll to top
  const scrollToTop = () => {
    topRef.current?.scrollIntoView({ behavior: 'smooth' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Collapse sidebar when on Premium page
  useEffect(() => {
    if (location.pathname === '/Premium') {
      setIsSidebarCollapsed(true);
    }

    return () => {
      // If navigating away from Premium page, you could reset sidebar
      // but better to let other pages control this themselves
    };
  }, [location.pathname, setIsSidebarCollapsed]);

  // Check if user was redirected from a premium feature
  useEffect(() => {
    if (location.state && location.state.fromPremiumRoute) {
      setShowRedirectMessage(true);
      setAttemptedPath(location.state.attemptedPath || 'premium features');

      // Auto-hide the message after 8 seconds
      const timer = setTimeout(() => {
        setShowRedirectMessage(false);
      }, 8000);

      return () => clearTimeout(timer);
    }
  }, [location]);

  const tiers = [
    {
      name: "En Passant",
      price: "$4.99/mo",
      features: ["Ad-free experience", "Basic engine analysis", "Basic creator tools"],
    },
    {
      name: "Bishop Pair",
      price: "$11.99/mo",
      additionalFeatures: ["Unlimited engine analysis", "PGN to MP4 automation (limited)"],
    },
    {
      name: "Smothered Mate",
      price: "$24.99/mo",
      additionalFeatures: [
        "Priority placement",
        "PGN to MP4 automation (unlimited)",
        "Early access to beta features",
        "Priority support",
      ],
    },
  ];



  return (
    <div className="app-container" style={{

      color: "#fff",
    }}>
      {/* Include the font style definition */}
      <MansalvaFontStyle />

      <div className="explore-container main-column" style={{
        maxHeight: "calc(100vh - 10px)",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
        scrollbarWidth: "thin",
        scrollbarColor: "gold transparent",
        padding: "20px 20px",
        background: 'linear-gradient(to bottom, #1a1a2e 0%, #16213e 50%, #0f3460 100%)'
        // background: "linear-gradient(to top, #3066BE, black)",
      }}>
        <div ref={topRef} style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "10px",
          marginBottom: "0px"
        }}>
          <img src={chessslogo} alt="Chess Logo" style={{ width: "150px", height: "auto", marginBottom: "10px" }} />


        </div>


        {/* Standalone Creative Mastery */}
        <div style={{
          border: "5px solid gold",
          color: "gold",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '15px 0px',
          flexDirection: 'column',
          fontSize: "35px",
          fontWeight: "bold",
          background: "rgba(48, 102, 190, 0.4)",
          width: '800px',
          marginBottom: '30px',
          borderRadius: "8px",
          boxShadow: "0 0 30px rgba(0,0,0,0.5)"
        }}>
          U&nbsp;N&nbsp;L&nbsp;O&nbsp;C&nbsp;K&nbsp;&nbsp;&nbsp;&nbsp;C&nbsp;R&nbsp;E&nbsp;A&nbsp;T&nbsp;I&nbsp;V&nbsp;E&nbsp;&nbsp;&nbsp;&nbsp;M&nbsp;A&nbsp;S&nbsp;T&nbsp;E&nbsp;R&nbsp;Y
        </div>


        {/* Pricing Section */}
        <div className="pricing-container" style={{
          padding: "15px",
          display: "flex",
          justifyContent: "center",
          gap: "30px",
          marginBottom: "30px"
        }}>
          {tiers.map((tier) => (
            <div
              key={tier.name}
              className="pricing-card"
              style={{
                background: tier.name === "Bishop Pair"
                  ? "linear-gradient(135deg, #ffd700, #e6c200)"
                  : "rgba(0,0,0,0.3)",
                color: tier.name === "Bishop Pair" ? "black" : "white",
                padding: "25px",
                border: tier.name === "Bishop Pair" ? "8px solid rgba(255,255,255,0.2)" : "3px solid gold",
                borderRadius: "12px",
                width: tier.name === "Bishop Pair" ? "300px" : "270px",
                transform: tier.name === "Bishop Pair" ? "scale(1.1)" : "scale(1)",
                textAlign: "center",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                boxShadow: tier.name === "Bishop Pair"
                  ? "0 0 30px rgba(255, 215, 0, 0.5)"
                  : "0 0 20px rgba(0,0,0,0.3)",
                "&:hover": {
                  transform: tier.name === "Bishop Pair" ? "scale(1.12)" : "scale(1.02)",
                  boxShadow: tier.name === "Bishop Pair"
                    ? "0 0 40px rgba(255, 215, 0, 0.7)"
                    : "0 0 25px rgba(255, 215, 0, 0.3)"
                }
              }}
            >
              {tier.name === "Bishop Pair" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-15px",
                    right: "50%",
                    transform: "translateX(50%)",
                    background: "#3066BE",
                    color: "gold",
                    padding: "8px 16px",
                    borderRadius: "20px",
                    fontSize: "1rem",
                    fontWeight: "bold",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                    border: "2px solid black"
                  }}
                >
                  Most Popular
                </div>
              )}
              <h2 style={{
                fontSize: tier.name === "Bishop Pair" ? "40px" : "28px",
                fontWeight: "bold",
                marginTop: tier.name === "Bishop Pair" ? "30px" : "20px",
                marginBottom: "15px"
              }}>
                {tier.name}
              </h2>
              <div className="price" style={{
                fontSize: tier.name === "Bishop Pair" ? "2.2rem" : "1.8rem",
                margin: "15px 0",
                fontWeight: "bold"
              }}>
                {tier.price}
              </div>
              <button
                className="checkout-button"
                style={{
                  background: tier.name === "Bishop Pair" ? "#3066be" : tier.name === "En Passant" ? "#26a69a" : "#ffca28",
                  color: tier.name === "Bishop Pair" ? "gold" : "#000",
                  border: "3px solid black",
                  padding: "16px 40px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "22px",
                  fontWeight: "bold",
                  marginTop: "20px",
                  transition: "all 0.2s ease",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                  "&:hover": {
                    transform: "translateY(-3px)",
                    boxShadow: "0 6px 12px rgba(0,0,0,0.4)"
                  }
                }}
                onClick={() => {
                  if (tier.name === "En Passant") {
                    
                    window.location.href = "https://buy.stripe.com/4gwbKnf3E5DIdwI002";
                  } else if (tier.name === "Bishop Pair") {
                    window.location.href = "https://buy.stripe.com/6oEeWzcVwgim50c7st";
                  } else if (tier.name === "Smothered Mate") {
                    window.location.href = "https://buy.stripe.com/6oEbKncVwc26eAM5kk";
                  } 
                }}
              >
                U&nbsp;P&nbsp;G&nbsp;R&nbsp;A&nbsp;D&nbsp;E
              </button>
              <div style={{
                fontSize: "16px",
                color: tier.name === "Bishop Pair" ? "black" : "#ccc",
                fontStyle: "italic",
                marginTop: "20px",
                textAlign: "center"
              }}>
                {tier.name === "En Passant" ? "for Passionate Players" : tier.name === "Bishop Pair" ? "for Aspiring Creators" : "for Coaches & Storytellers"}
              </div>
            </div>
          ))}
        </div>

        <p style={{
          fontSize: "1.8rem",
          color: "white",
          textAlign: "center",
          maxWidth: "850px",
          marginBottom: "40px",
          lineHeight: "1.4",
          fontStyle: "italic"
        }}>
          Elevate your chess experience with our premium features designed for serious players and content creators . . .
        </p>


        {/* Feature Comparison Table */}
        <div className="feature-comparison" style={{
          padding: "30px",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          background: "rgba(0,0,0,0.3)",
          borderRadius: "12px",
          border: "1px solid gold",
          boxShadow: "0 0 30px rgba(0,0,0,0.5)",
          width: "950px",
          margin: "0 auto"
        }}>
          <div className="premium-hero" style={{ textAlign: "center", color: "gold", marginBottom: "20px" }}>

            <div style={{
              border: "5px solid rgba(128,128,128,0.5)",
              color: "white",
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '15px 0px',
              flexDirection: 'column',
              fontSize: "35px",
              fontWeight: "bold",
              background: "rgba(0,0,0,0.5)",
              width: '600px',
              marginBottom: "15px",
              borderRadius: "8px"
            }}>
              C&nbsp;O&nbsp;M&nbsp;P&nbsp;A&nbsp;R&nbsp;E&nbsp;&nbsp;&nbsp;P&nbsp;L&nbsp;A&nbsp;N&nbsp;S
              <br />
              <span style={{ fontSize: "30px", color: "gold", width: "800px", paddingTop: "15px", margin: "0", fontWeight: "normal" }}>
                Opening Discount: <span style={{ color: "#FF0050" }}>Offer</span>
              </span>
            </div>



          </div>
          <table style={{
            border: "5px solid gold",
            width: "850px",
            borderCollapse: "collapse",
            textAlign: "center",
            fontSize: "20px",
            borderRadius: "15px",
            overflow: "hidden",

          }}>
            <thead>
              <tr>
                <th style={{
                  padding: "20px",
                  height: "70px",
                  background: "#121212",
                  borderBottom: "2px solid gold",
                  width: "30%",
                  fontSize: "30px",
                  fontWeight: "bold",
                  color: "white"
                }}>Feature</th>
                <th style={{
                  padding: "20px",
                  background: "#26a69a",
                  color: "black",
                  borderBottom: "2px solid gold",
                  fontSize: "24px",
                  fontWeight: "bold",
                  width: "23%"
                }}>En Passant</th>
                <th style={{
                  padding: "20px",
                  background: "#ff7043",
                  color: "black",
                  borderBottom: "2px solid gold",
                  fontSize: "24px",
                  fontWeight: "bold",
                  width: "23%"
                }}>Bishop Pair</th>
                <th style={{
                  padding: "20px",
                  background: "#ffca28",
                  color: "black",
                  borderBottom: "2px solid gold",
                  fontSize: "24px",
                  fontWeight: "bold",
                  width: "24%"
                }}>Smothered Mate</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: "20px", fontWeight: "bold" }}>
              <tr>
                <td style={{
                  padding: "15px",
                  height: "60px",
                  textAlign: "center",
                  borderBottom: "1px solid #444",
                  background: "rgba(0,0,0,0.2)"
                }}>No Ads,<br />Just Chess.</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "gold", background: "rgba(38, 166, 154, 0.1)", fontSize: "30px" }}>✓</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "gold", background: "rgba(255, 112, 67, 0.1)", fontSize: "30px" }}>✓</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "gold", background: "rgba(255, 202, 40, 0.1)", fontSize: "30px" }}>✓</td>
              </tr>

              <tr>
                <td style={{
                  padding: "15px",
                  height: "60px",
                  textAlign: "center",
                  borderBottom: "1px solid #444",
                  background: "rgba(0,0,0,0.2)"
                }}>

                  <div className="tooltip-container-2" style={{}}>
                    <i
                      className="fa-solid fa-info-circle"
                      style={{ cursor: 'pointer', color: 'gold', fontSize: '24px', marginRight: '10px' }}
                    ></i>
                    <div className="tooltip-2 " style={{ width: '850px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                      <div className="" style={{ textAlign: 'left', fontSize: '18px', paddingBottom: '', width: '825px', color: 'gold', paddingLeft: '20px' }}>
                        - Engine analysis is FREE for all users on the Analyze & Share tab.<br />- Premium users also get engine access while viewing<br />&nbsp;&nbsp;&nbsp;&nbsp;other user's games elsewhere on the website. Hacks...
                      </div>
                      <div><i className="fa-solid fa-robot" style={{ color: '#58b047', fontSize: '40px', paddingRight: '90px' }}></i></div>
                    </div>
                  </div>

                  24/7 Stockfish<br />Engine Analysis</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "gold", background: "rgba(38, 166, 154, 0.1)", fontSize: "30px" }}>✓</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "gold", background: "rgba(255, 112, 67, 0.1)", fontSize: "30px" }}>✓</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "gold", background: "rgba(255, 202, 40, 0.1)", fontSize: "30px" }}>✓</td>
              </tr>

              <tr>
                <td style={{
                  padding: "15px",
                  height: "60px",
                  textAlign: "center",
                  borderBottom: "1px solid #444",
                  background: "rgba(0,0,0,0.2)"
                }}>Visibility Boost</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "red", background: "rgba(38, 166, 154, 0.1)", fontSize: "30px" }}>✗</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "gold", background: "rgba(255, 112, 67, 0.1)", fontSize: "30px" }}>✓</td>
                <td style={{ fontSize: "30px", padding: "", height: "", borderBottom: "1px solid #444", color: "gold", background: "rgba(255, 202, 40, 0.1)" }}>✓</td>
              </tr>
              <tr>
                <td style={{
                  padding: "15px",
                  height: "60px",
                  textAlign: "center",
                  borderBottom: "1px solid #444",
                  background: "rgba(0,0,0,0.2)"
                }}>Automate Videos<br />For Social Media</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "gold", background: "rgba(38, 166, 154, 0.1)", fontSize: "22px" }}>2 / month</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "gold", background: "rgba(255, 112, 67, 0.1)", fontSize: "22px" }}>10 / month</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "gold", fontSize: "22px", background: "rgba(255, 202, 40, 0.1)" }}>Unlimited</td>
              </tr>
              <tr>
                <td style={{
                  padding: "15px",
                  height: "60px",
                  textAlign: "center",
                  borderBottom: "1px solid #444",
                  background: "rgba(0,0,0,0.2)"
                }}>Monetization & Creator Support</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "red", background: "rgba(38, 166, 154, 0.1)", fontSize: "30px" }}>✗</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "gold", background: "rgba(255, 112, 67, 0.1)", fontSize: "22px" }}>Coming</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "gold", background: "rgba(255, 202, 40, 0.1)", fontSize: "22px" }}>Soon</td>
              </tr>
              <tr>
                <td style={{
                  padding: "15px",
                  height: "60px",
                  textAlign: "center",
                  borderBottom: "1px solid #444",
                  background: "rgba(0,0,0,0.2)"
                }}>Locked Price &<br /> More Coming</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "gold", background: "rgba(38, 166, 154, 0.1)", fontSize: "30px" }}>✓</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "gold", background: "rgba(255, 112, 67, 0.1)", fontSize: "30px" }}>✓</td>
                <td style={{ padding: "15px", height: "60px", borderBottom: "1px solid #444", color: "gold", background: "rgba(255, 202, 40, 0.1)", fontSize: "30px" }}>✓</td>
              </tr>
              {/* Add new price and button row at the bottom */}
              <tr>
                <td style={{ padding: "20px", borderTop: "2px solid gold", background: "rgba(0,0,0,0.3)" }}></td>
                <td style={{ padding: "20px", borderTop: "2px solid gold", background: "rgba(38, 166, 154, 0.2)" }}>
                  <div style={{ fontSize: "26px", fontWeight: "bold", marginBottom: "15px" }}>$4.99/mo</div>
                  <button style={{
                    background: "#26a69a",
                    color: "white",
                    padding: "12px 24px",
                    border: "3px solid black",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginBottom: "10px",
                    transition: "all 0.2s ease",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.3)"
                  }}>SELECT PLAN</button>
                  <div style={{
                    fontSize: "14px",
                    color: "#ccc",
                    fontStyle: "italic",
                    marginTop: "10px"
                  }}>for<br />Passionate Players</div>
                </td>
                <td style={{ padding: "20px", borderTop: "2px solid gold", background: "rgba(255, 112, 67, 0.2)" }}>
                  <div style={{ fontSize: "26px", fontWeight: "bold", marginBottom: "15px" }}>$11.99/mo</div>
                  <button style={{
                    background: "#ff7043",
                    color: "white",
                    padding: "12px 24px",
                    border: "3px solid black",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginBottom: "10px",
                    transition: "all 0.2s ease",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.3)"
                  }}>SELECT PLAN</button>
                  <div style={{
                    fontSize: "14px",
                    color: "#ccc",
                    fontStyle: "italic",
                    marginTop: "10px"
                  }}>for<br />Aspiring Creators</div>
                </td>
                <td style={{ padding: "20px", borderTop: "2px solid gold", background: "rgba(255, 202, 40, 0.2)" }}>
                  <div style={{ fontSize: "26px", fontWeight: "bold", marginBottom: "15px" }}>$24.99/mo</div>
                  <button style={{
                    background: "#ffca28",
                    color: "black",
                    padding: "12px 40px",
                    border: "3px solid black",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginBottom: "10px",
                    transition: "all 0.2s ease",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.3)"
                  }}>SELECT<br />PLAN</button>
                  <div style={{
                    fontSize: "14px",
                    color: "#ccc",
                    fontStyle: "italic",
                    marginTop: "10px",
                    width: "165px"
                  }}>for<br />Coaches & Storytellers</div>
                </td>
              </tr>
            </tbody>
          </table>

        </div>





        {/* Why Upgrade Section */}
        <div className="" style={{
          padding: "30px",
          marginTop: "40px",
          maxWidth: "950px",
          width: "100%",
          background: "rgba(0,0,0,0.3)",
          borderRadius: "12px",
          boxShadow: "0 0 30px rgba(0,0,0,0.5)",
          border: "1px solid gold"
        }}>
          <div style={{
            padding: "20px",
            maxWidth: "900px",
            margin: "0 auto",
            borderRadius: "8px"
          }}>
            <h1 style={{
              fontSize: "46px",
              marginBottom: "30px",
              color: "gold",
              textAlign: "center",
              fontWeight: "bold",
              textShadow: "0 0 10px rgba(255, 215, 0, 0.3)"
            }}>WHY UPGRADE TO PREMIUM?</h1>

            <div style={{ borderBottom: "3px solid gold", width: "100%", margin: "0 0 40px 0" }}></div>

            {/* Feature Grid Layout */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "30px", marginBottom: "40px" }}>
              {/* Feature 1 - Social Media Presence */}
              <div style={{
                background: "linear-gradient(135deg, #13274F 0%, #2A4D8F 100%)",
                borderRadius: "12px",
                padding: "30px",
                boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
                border: "1px solid rgba(255,215,0,0.3)",
                height: "100%"
              }}>
                <h2 style={{
                  fontSize: "28px",
                  marginBottom: "20px",
                  color: "gold",
                  fontWeight: "bold",
                  borderBottom: "2px solid gold",
                  paddingBottom: "10px"
                }}>
                  Grow Your Social Media Presence, <span style={{ color: "gold" }}>Everywhere . . .</span>
                </h2>
                <ul style={{
                  fontSize: "19px",
                  margin: "0 auto",
                  textAlign: "left",
                  padding: "10px 20px",
                  lineHeight: "1.6",
                  listStyleType: "disc",
                  color: "white",
                  minHeight: "200px"
                }}>
                  <li style={{ marginBottom: "15px" }}>Scale your content creation to reach new audiences.</li>
                  <li style={{ marginBottom: "15px" }}>Export for YouTube, TikTok, and Instagram in just a few clicks.</li>
                  <li style={{ marginBottom: "15px" }}>A modern approach to Chess Content Automation, saving time and headaches!</li>
                </ul>
              </div>

              {/* Feature 2 - Chess Enjoyment */}
              <div style={{
                background: "linear-gradient(135deg, #13274F 0%, #2A4D8F 100%)",
                borderRadius: "12px",
                padding: "30px",
                boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
                border: "1px solid rgba(255,215,0,0.3)",
                height: "100%"
              }}>
                <h2 style={{
                  fontSize: "28px",
                  marginBottom: "20px",
                  color: "gold",
                  fontWeight: "bold",
                  borderBottom: "2px solid gold",
                  paddingBottom: "10px"
                }}>
                  Maximize Your Chess Enjoyment & Learning
                </h2>
                <ul style={{
                  fontSize: "19px",
                  margin: "0 auto",
                  textAlign: "left",
                  padding: "10px 20px",
                  lineHeight: "1.6",
                  listStyleType: "disc",
                  color: "white",
                  minHeight: "200px"
                }}>
                  <li style={{ marginBottom: "15px" }}>Enjoy an ad-free, Chess-only experience.</li>
                  <li style={{ marginBottom: "15px" }}>Unlimited engine analysis when interacting with other chess media.</li>
                  <li style={{ marginBottom: "15px" }}>Receive a boost in visibility for quality-assured content.</li>
                </ul>
              </div>

              {/* Feature 3 - Other Benefits For Premium Members */}
              <div style={{
                background: "linear-gradient(135deg, #13274F 0%, #2A4D8F 100%)",
                borderRadius: "12px",
                padding: "30px",
                boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
                border: "1px solid rgba(255,215,0,0.3)",
                height: "100%",
                gridColumn: "1 / 2"
              }}>
                <div style={{
                  fontSize: "28px",
                  marginBottom: "20px",
                  color: "gold",
                  fontWeight: "bold",
                  borderBottom: "2px solid gold",
                  paddingBottom: "10px",
                  marginTop: "22px"
                }}>
                  Royalty Wears A Crown                <img src={CrownGold} alt="Crown" style={{ width: "30px", height: "30px", marginLeft: "" }} />

                </div>
                <ul style={{
                  fontSize: "19px",
                  margin: "0 auto",
                  textAlign: "left",
                  padding: "10px 20px",
                  lineHeight: "1.6",
                  listStyleType: "disc",
                  color: "white",
                  minHeight: "200px"
                }}>
                  <li style={{ marginBottom: "15px" }}>Be a genuis in public analysis,<br />with the help of the engine.</li>
                  <li style={{ marginBottom: "" }}>Stand out with a shiny crown beside your username.</li>
                </ul>
                <div style={{ display: "flex", justifyContent: "", flexDirection: "column", alignItems: "center", gap: '10px' }}>

                  <div style={{ color: "white", fontSize: "24px", fontWeight: "", display: "flex", flexDirection: "row", alignItems: "center", width: "" }}>@SomePawn</div>

                  <div style={{ color: "#cd7f32", fontSize: "24px", fontWeight: "", display: "flex", flexDirection: "row", alignItems: "center", width: "" }}>@EnPassant<img src={CrownBronze} alt="Crown" style={{ width: "30px", height: "30px", marginLeft: "5px" }} /></div>
                  <div style={{ color: "#c0c0c0", fontSize: "24px", fontWeight: "", display: "flex", flexDirection: "row", alignItems: "center", width: "" }}>@BishopPair<img src={CrownSilver} alt="Crown" style={{ width: "30px", height: "30px", marginLeft: "5px" }} /></div>
                  <div style={{ color: "gold", fontSize: "24px", fontWeight: "", display: "flex", flexDirection: "row", alignItems: "center", width: "" }}>@SmotheredMate<img src={CrownGold} alt="Crown" style={{ width: "30px", height: "30px", marginLeft: "5px" }} /></div>
                </div>
              </div>

              {/* Feature 4 - Premium Experience */}
              <div style={{
                background: "linear-gradient(135deg, #13274F 0%, #2A4D8F 100%)",
                borderRadius: "12px",
                padding: "30px",
                boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
                border: "1px solid rgba(255,215,0,0.3)",
                height: "100%",
                gridColumn: "2 / 3"
              }}>
                <h2 style={{
                  fontSize: "28px",
                  marginBottom: "20px",
                  color: "gold",
                  fontWeight: "bold",
                  borderBottom: "2px solid gold",
                  paddingBottom: "10px"
                }}>
                  Real Premium Value
                </h2>


                <ul style={{
                  fontSize: "19px",
                  margin: "0 auto",
                  textAlign: "left",
                  padding: "0 20px",
                  lineHeight: "1.6",
                  listStyleType: "disc",
                  color: "white"
                }}>
                  <li style={{ marginBottom: "15px" }}>Build your brand on the fastest growing chess platform.</li>
                  <li style={{ marginBottom: "15px" }}>Early access to more innovative features and tools, such as monetization.</li>
                  <li style={{ marginBottom: "40px" }}>Direct access to our support and product team. We want to hear from you, and help you grow!</li>

                </ul>
                <div style={{ textAlign: "center" }}>
                  <button
                    style={{
                      marginTop: "20px",
                      padding: "15px 30px",
                      backgroundColor: "gold",
                      color: "black",
                      border: "3px solid black",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      fontSize: "18px",
                      transition: "all 0.2s ease"
                    }}
                    onClick={scrollToTop}
                  >
                    Upgrade To Premium
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Clickable logo and text to return to top */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              cursor: "pointer",
              marginTop: "50px"
            }}
            onClick={scrollToTop}
          >
            <img
              src={chessslogo}
              alt="Chess Logo"
              style={{
                width: "150px",
                height: "auto",
                marginBottom: "5px",
                transition: "transform 0.2s ease"
              }}
            />
            <p style={{
              fontSize: "26px",
              color: "gold",
              textAlign: "center",
              marginBottom: "10px",
              lineHeight: "1.4",
              fontFamily: "Mansalva, cursive",
              transition: "color 0.2s ease",
              marginTop: "5px"
            }}>
              ChessThread.com
            </p>
          </div>
          <div
            style={{
              fontSize: "50px",
              fontWeight: "bold",
              color: "gold",
              textAlign: "center",
              display: "flex",
              flexDirection: "row",
              alignItems: "end",
              justifyContent: "center",
              width: "100%",
              marginTop: "30px",
              textShadow: "0 0 10px rgba(0,0,0,0.7)",
              cursor: "pointer",
              transition: "transform 0.2s ease"
            }}
            onClick={scrollToTop}
          >
            Make Chess Content Easy.
          </div>

        </div>

      </div>

    </div>
  );
};

Premium.propTypes = {
  getScreams: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
});

export default connect(mapStateToProps, { getScreams })(Premium);
